import { translate } from "../../util/translate"

export const realEstateContractHeaders = [
  {
    text: translate['contract.label.date_created'],
    value: 'date_created',
    width: '180',
  },
  {
    text: translate['contract.label.type'],
    value: 'type',
    width: '300',
  },
  {
    text: translate['contract.label.startDate'],
    value: 'start_date',
    width: '180',
  },
  {
    text: translate['contract.label.endDate'],
    value: 'end_date',
    width: '180',
  },
  {
    text: translate['contract.label.is_active'],
    value: 'is_active',
    align: 'center',
    width: '80',
  },
  { value: 'actions', align: 'end', width: '100' },
]
